import React, { memo, useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { createSelector } from 'reselect';
import { setActiveMenu, setFirstRun } from '../../actions/layout';
import { logging, logPostInfo } from '../../actions/log';
import { getLocalMachineInfo, installSoftList } from '../../actions/native';
import { installAndroidSoftList } from '../../actions/anative';
import {
  getRecoBanner,
  getRecoRecommend,
  getSoftInfos,
  getGuessLikes,
} from '../../actions/recommend';
import CardIndex from '../../card/CardIndex/CardIndex';
import { CONTEXT } from '../../config';
import { getQueryString, getParamString } from '../../utils/utils';
import Welcome from '../Welcome/Welcome';
import GuessLikes from './GuessLikes';
import styles from './Recommend.module.less';
import Loading from '../../components/Loading/Loading';
import { welcomePopTime } from '../../constants/storageKeys';
import dayjs from 'dayjs';

const selectRecoBanner = createSelector(
  state => state.recommend,
  recommend => recommend.recoBanner,
);
const selectRecoRecommend = createSelector(
  state => state.recommend,
  recommend => recommend.recoRecommend,
);

const selectSoftInfos = createSelector(
  state => state.recommend,
  recommend => recommend.softInfos,
);

const selectCommandLine = createSelector(
  state => state.native,
  native => native.commandLine,
);
const selectLocalMachineInfo = createSelector(
  state => state.native,
  native => native.machineInfo,
);
const selectFirstRun = createSelector(
  state => state.layout,
  layout => layout.firstRun,
);
const selectWelcomeData = createSelector(
  state => state.welcome,
  welcome => welcome.welcomeData,
);
const selectWelcomeInit = createSelector(
  state => state.welcome,
  welcome => welcome.init,
);

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUpgradeSofts = createSelector(
  state => state.native,
  native => native.upgradeSofts,
);

const selectSilentInstSoft = createSelector(
  state => state.native,
  native => native.supportSilentInstSoft,
);
const selectIsEnabledSilent = createSelector(
  state => state.layout,
  layout => layout.isEnabledSilent,
);

export default memo(() => {
  const dispatch = useDispatch();
  const location = useLocation();
  const commandLine = useSelector(selectCommandLine);
  const history = useHistory();
  const firstRun = useSelector(selectFirstRun);
  const welcomeData = useSelector(selectWelcomeData);
  const welcomeInit = useSelector(selectWelcomeInit);
  const machineInfo = useSelector(selectLocalMachineInfo);
  const upgradeSofts = useSelector(selectUpgradeSofts); // 可更新
  const silentInstSoft = useSelector(selectSilentInstSoft); // 支持快速静默安装的应用列表
  const isEnabledSilent = useSelector(selectIsEnabledSilent); // 是否打开快速静默安装

  const recoBanner = useSelector(selectRecoBanner);
  const recoRecommend = useSelector(selectRecoRecommend);

  const softInfos = useSelector(selectSoftInfos);

  const logInfoData = useSelector(selectLogInfo);

  const [getBannerKey, setGetBannerKey] = useState(null);
  const [tagSource, setTagSource] = useState(null);
  const [welcome, setWelcome] = useState(false); // 判断欢迎页是否被弹出
  const [welcomeLoadImg, setWelcomeLoadImg] = useState(false); // 判断欢迎页是否被弹出

  const skipOtherPage = () => {
    let skip = false;
    // 管家直接进入详情页 并且触发下载
    if (commandLine && commandLine.indexOf('-c pcm_security_install') > -1) {
      const softID = commandLine.split('#')[1] || '';
      const bizId = commandLine.split('#')[2] || '';
      if (softID || bizId) {
        skip = true;
      }
    }
    const params = [
      '-c pcm_toolbox_update',
      '-c pcm_toolbox_uninstall',
      '-c pcm_tanchuang',
      '-c pcm_clean_uninstall',
      '-c pcm_hidden_install',
    ];

    // 调起商店，并跳入某个页面
    if (commandLine && params.find(item => commandLine.indexOf(item) > -1)) {
      skip = true;
    }
    if (commandLine && commandLine.indexOf('-c open_page') > -1) {
      const page = getParamString('page', commandLine);
      if (page !== 'recommend') {
        skip = true;
      }
    }
    return skip;
  };
  /**
   * 判断欢迎页是否已经被弹出
   */
  useEffect(() => {
    const HistoryLen = (history && history.length) || 0;
    // const nowTime = dayjs(+new Date()).format('YYYYMMDD');
    // const popTime = localStorage.getItem(welcomePopTime) || 0;
    // 首次·掉起商店跳入其他页面 不显示
    if (!commandLine || (HistoryLen < 2 && skipOtherPage())) {
      return;
    }
    // if (HistoryLen < 2 && nowTime - popTime) {
    if (HistoryLen < 2) {
      setWelcome(true);
    } else {
      setWelcome(false);
    }
  }, [commandLine]);

  /**
   * 统计页面浏览时长
   */
  useEffect(() => {
    const initTime = +new Date();
    return () => {
      const leaveTime = +new Date();
      dispatch(
        logging({
          category: 'I',
          action: 'View_Time',
          label: '',
          param2: {
            source: `Recommend`,
            source: tagSource || `Recommend`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            initTime,
            leaveTime,
            time: leaveTime - initTime,
          },
        }),
      );
    };
  }, [tagSource]);

  // 处理进入推荐页面就开始批量下载软件。
  useEffect(() => {
    const softIdsStr = getQueryString('softIds', location.search) || '';
    const pnsStr = getQueryString('pns', location.search) || '';
    const bizInfoStr = getQueryString('bizInfo', location.search) || '{}';
    if ((softIdsStr || pnsStr) && bizInfoStr) {
      const softIds = softIdsStr ? softIdsStr.split(',') : [];
      const pns = pnsStr ? pnsStr.split(',') : [];
      const bizInfo = JSON.parse(bizInfoStr);
      dispatch(getSoftInfos({ softIds, pns, bizInfo }));
    }
  }, [dispatch, commandLine, location.search]);

  /**
   * 进入页面就下载, 等待更新列表获取完成才开始下载
   */
  useEffect(() => {
    const softIdsStr = getQueryString('softIds', location.search) || '';
    const pnsStr = getQueryString('pns', location.search) || '';
    const bizInfoStr = getQueryString('bizInfo', location.search) || '{}';
    const recoIsDownload = sessionStorage.getItem('recoIsDownload');
    if (
      softInfos &&
      softInfos.data &&
      softInfos.data.length > 0 &&
      softInfos.softIds.join(',') === softIdsStr &&
      softInfos.pns.join(',') === pnsStr &&
      silentInstSoft &&
      silentInstSoft.length >= 0 &&
      upgradeSofts &&
      upgradeSofts.length != undefined &&
      location &&
      location.search &&
      (!recoIsDownload || recoIsDownload !== `${softIdsStr}&${pnsStr}`)
    ) {
      const androidSoftList = [];
      const pcSoftList = [];
      softInfos.data.forEach(softItem => {
        const upgrade = upgradeSofts.find(
          soft_ =>
            (soft_.androidType !== '1' &&
              (soft_.softID === softItem.softID || soft_.SoftID === softItem.softID)) ||
            (soft_.androidType === '1' && soft_.packageName === softItem.packageName),
        );
        if (softItem && softItem.androidType === '1') {
          const logParam2 = {
            source: 'Recommend',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softItem.packageName,
            softName: softItem.softName,
            packageName: softItem.packageName,
            versionCode: softItem.versionCode,
            softType: '1',
            type: upgrade ? 'u' : 'd',
            url: softItem.downLoadUrl || softItem.downloadUrl,
          };
          androidSoftList.push({ ...softItem, logInfo: logParam2, bizInfo: bizInfoStr });
        } else {
          const installparams = {};
          const logParam2 = {
            source: 'Recommend',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: softItem.softID,
            softName: softItem.softName,
            softType: '0',
            type: upgrade ? 'u' : 'd',
            url: softItem.downLoadUrl || softItem.downloadUrl,
          };

          if (silentInstSoft && isEnabledSilent) {
            const silentSoft = silentInstSoft.find(soft_ => soft_.softID === softItem.softID);
            if (silentSoft && silentSoft.softID) {
              logParam2.type = upgrade ? 'xu' : 'xd';
              if (silentSoft.silentParamDic) {
                installparams.quiet = silentSoft.silentParamDic;
              }
              if (silentSoft.silentDirParamDic) {
                installparams.todir = silentSoft.silentDirParamDic;
              }
            }
          }
          pcSoftList.push({ ...softItem, logInfo: logParam2, installparams, bizInfo: bizInfoStr });
        }
      });
      if (androidSoftList.length > 0) {
        dispatch(installAndroidSoftList(androidSoftList));
      }
      if (pcSoftList.length > 0) {
        dispatch(installSoftList(pcSoftList));
      }
      sessionStorage.setItem('recoIsDownload', `${softIdsStr}&${pnsStr}`);
    }
  }, [dispatch, softInfos, logInfoData, upgradeSofts, silentInstSoft, location]);

  useEffect(() => {
    if (!machineInfo) {
      dispatch(getLocalMachineInfo());
    }
    // if (machineInfo && commandLine) {
    if (machineInfo && (commandLine || firstRun)) {
      // 推荐页面PV打桩  必须设备信息获取成功之后进行
      dispatch(
        logging({
          category: 'P',
          action: 'Recommend',
          label: '',
          param2: {
            source: 'Recommend',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
      dispatch(
        logPostInfo({
          source: 'Recommend',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        }),
      );
    }
  }, [dispatch, machineInfo, commandLine, firstRun]);

  useEffect(() => {
    if (commandLine && firstRun) {
      // 在这里控制FirstRun
      dispatch(setFirstRun(false));
      // 管家--工具箱--软件升级
      if (commandLine.indexOf('-c pcm_main') > -1) {
        dispatch(setActiveMenu(`${CONTEXT}/recommend`));
        history.push(`${CONTEXT}/recommend`);
      }
      // 管家--工具箱--软件升级
      if (commandLine.indexOf('-c pcm_toolbox_update') > -1) {
        dispatch(setActiveMenu(`${CONTEXT}/update`));
        history.push(`${CONTEXT}/update`);
      }

      // 管家--工具箱--软件卸载
      if (commandLine.indexOf('-c pcm_toolbox_uninstall') > -1) {
        dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
        history.push(`${CONTEXT}/uninstall`);
      }

      // 管家-软件升级弹窗
      if (commandLine.indexOf('-c pcm_tanchuang') > -1) {
        dispatch(setActiveMenu(`${CONTEXT}/update`));
        history.push(`${CONTEXT}/update`);
      }

      if (commandLine.indexOf('-c pcm_tanchuang_kaiji') > -1) {
        const softID = commandLine.split('#')[1];
        const bizInfo = JSON.stringify({});
        if (softID) {
          history.push(`${CONTEXT}/detail/soft/${softID}/${bizInfo}`);
        }
      }
      // 管家--垃圾清理--软件卸载
      if (commandLine.indexOf('-c pcm_clean_uninstall') > -1) {
        dispatch(setActiveMenu(`${CONTEXT}/uninstall`));
        history.replace(`${CONTEXT}/uninstall`);
      }
    }
  }, [commandLine, firstRun]);

  /**
   * 获取banner数据，每次进来都获取
   * 因为广告接入，计算统计接口请求，和展示次数矛盾。
   * 所以改为：每次展示banner，都重新请求一次数据
   */
  useEffect(() => {
    const getBannerKeyNum = +new Date();
    setGetBannerKey(getBannerKeyNum);
    dispatch(getRecoBanner({ getBannerKey: getBannerKeyNum, pageType: 'soft' }));
  }, [dispatch]);

  /**
   * 获取card list 数据
   */
  useEffect(() => {
    if (
      !recoRecommend ||
      !recoRecommend.data ||
      !recoRecommend.data.length ||
      recoRecommend.pageType !== 'soft'
    ) {
      dispatch(getRecoRecommend({ pageType: 'soft' }));
    }
  }, [dispatch, recoRecommend]);

  /**
   * 猜你喜欢
   */
  useEffect(() => {
    dispatch(getGuessLikes({ skip: 0, limit: 60 }));
  }, []);

  useEffect(() => {
    if (recoRecommend && recoRecommend.pageType === 'soft' && recoRecommend.data.length > 0) {
      setTagSource(`Reco_${recoRecommend.data[0].computerType}`);
      dispatch(
        logging({
          category: 'R',
          action: `Reco_${recoRecommend.data[0].computerType}`,
          label: '',
          param2: {
            source: `Reco_${recoRecommend.data[0].computerType}`,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
          },
        }),
      );
    }
  }, [recoRecommend]);

  useEffect(() => {
    if (welcomeData && welcomeData.tags) {
      let loaded = 0;
      welcomeData.tags.forEach((item, index) => {
        if (index < 4) {
          const imgs1 = new Image();
          imgs1.src = item.noSelectIcon;
          imgs1.onload = e => {
            loaded += 1;
            if (loaded >= 3) {
              setWelcomeLoadImg(true);
            }
          };
        }
      });
    }
  }, [welcomeData]);

  const changView = content => {
    dispatch(
      logging({
        category: 'I',
        action: 'Reco_Content_Show',
        label: '',
        param2: {
          source: 'Recommend',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          ...content,
        },
      }),
    );
  };

  if (
    !(
      recoBanner &&
      recoBanner.pageType === 'soft' &&
      recoBanner.getBannerKey === getBannerKey &&
      recoBanner.data &&
      recoBanner.data.length > 0 &&
      recoRecommend &&
      recoRecommend.pageType === 'soft' &&
      recoRecommend.data.length > 0
    )
  ) {
    return (
      <div className={styles.loading}>
        <Loading />
      </div>
    );
  }

  return (
    <div className={styles.reco}>
      {tagSource &&
        recoBanner &&
        recoBanner.pageType === 'soft' &&
        recoBanner.getBannerKey === getBannerKey &&
        recoBanner.data &&
        recoBanner.data.length > 0 &&
        recoRecommend &&
        recoRecommend.pageType === 'soft' &&
        recoRecommend.data.length > 0 && (
          <React.Fragment>
            <div className={styles.reco_banner}>
              {recoBanner.data.map((item, i) => (
                <CardIndex data={{ ...item }} key={i} logInfo={{ tag: tagSource, changView }} />
              ))}
            </div>
            {recoRecommend.data.map((item, i) => (
              <CardIndex data={{ ...item }} key={i} logInfo={{ tag: tagSource, changView }} />
            ))}
          </React.Fragment>
        )}
      <GuessLikes logInfo={{ tag: tagSource, changView }} />
      {welcome && welcomeData && welcomeData.needShow && !welcomeInit && welcomeLoadImg && (
        <Welcome />
      )}
    </div>
  );
});
